import cacheableRequest from '../../../services/cacheableRequest';
import { AxiosResponse } from 'axios';
import { ChurchAccount } from '../models/churchAccount';

export const getAssociatedChurchAccounts = (): Promise<ChurchAccount[]> =>
  cacheableRequest('/v2/user/associated-church-accounts').then(
    (response: AxiosResponse<ChurchAccount[]>) => response.data
  );
